const DoubleArrowIcon = () => {
  return (
    <svg viewBox="0 0 12 10.5">
      <g transform="translate(-160 -946.75)">
        <path
          d="M52.837,55.837l4.5-4.5A.75.75,0,1,1,58.4,52.4l-3.97,3.97,3.97,3.97A.75.75,0,1,1,57.337,61.4l-4.5-4.5A.75.75,0,0,1,52.837,55.837Z"
          transform="translate(107.383 895.633)"
          fill="#075da9"
        />
        <path
          d="M52.837,55.837l4.5-4.5A.75.75,0,1,1,58.4,52.4l-3.97,3.97,3.97,3.97A.75.75,0,1,1,57.337,61.4l-4.5-4.5A.75.75,0,0,1,52.837,55.837Z"
          transform="translate(113.383 895.633)"
          fill="#075da9"
        />
      </g>
    </svg>
  );
};

export default DoubleArrowIcon;
